export default __webpack_public_path__ + "static/media/soul-and-mindful.9f80dee6.svg";